<template>
    <div class="quotation">
        <h2>{{ $route.query.title }}</h2>
        <div class="form">
            <div class="form-item">
                <div class="form-item">
                    <label>报 价 编 号</label>
                    ：<input v-model="form.number" type="text" />
                    <span></span>
                </div>
                <label>单 个 面 积</label>
                ：<input v-model="form.single" type="text" />
                <span>cm<sup>2</sup></span>
            </div>
            <!-- <div class="form-item">
                <label>白卡纸克重</label>
                ：<input v-model="form.weight" type="text" />
                <span>g/cm2</span>
            </div> -->

            <div class="form-item">
                <label>产品出厂价</label>
                ：<input v-model="form.price" type="text" />
                <span>元/个（选填）</span>
            </div>
        </div>
        <br /> <br />
        <div class="button-wapper">
            <span class="button" @click="goTo">确 定</span>
        </div>

    </div>
</template>
<script>
import { getDocQuotationCalculation, listDocQuotationCalculation } from "@/api/docQuotationCalculation"
export default {
    data() {
        return {
            config: {},
            form: {
                single: "",
                price: "",
                number: ''
            },
            // quotationCalculationlist: [],
            list: [
                { sort: '1.', name: '1. 白卡纸（纸盒/吊牌/挂牌）' },
                { sort: '2. ', name: '2. 不干胶（标签/瓶贴）' },
                { sort: '3. ', name: '3. 单张纸（合格证/说明书/浆糊瓶贴等）' },
                { sort: '4. ', name: '4. 封箱带' },
                { sort: '5. ', name: '5. 瓦楞纸箱面纸' },
                { sort: '6.1 ', name: '6.1 烟包硬盒框架纸' },
                { sort: '6.2 ', name: '6.2 烟包硬盒环保铝箔衬纸' },
                { sort: '6.3 ', name: '6.3 烟包硬盒外壳' },
                { sort: '6.4 ', name: '6.4 烟包软包封签纸' },
                { sort: '6.5 ', name: '6.5 烟包全开硬盒内卡纸' }]
        }
    },
    created() {
        getDocQuotationCalculation(this.$route.query._).then(res => {
            this.form.number = res.data.receiver
        })
        // listDocQuotationCalculation({ pageNum: 1, pageSize: 100, receiverId: this.$route.query._ }).then(res => {
        //     this.quotationCalculationlist = res.rows
        //     console.log(res)
        // })
    },
    methods: {
        goTo() {
            this.form._ = this.$route.query._
            this.$router.push({ path: '/quotation2-result', query: this.form })
        },
        // submit() {
        //     if (this.form.id) {
        //         let _oldData = JSON.parse(this.form.expandJson)
        //         _oldData.scales = this.proportion
        //         this.form.expandJson = JSON.stringify(_oldData)
        //         updateDocQuotationCalculation(this.form).then(res => {
        //             if (res.code == 200) {
        //                 this.quotationShow = false
        //                 this.getList()
        //             }
        //         })
        //     } else {
        //         this.form.expandJson = JSON.stringify({ scales: this.proportion, shares: [] })
        //         this.form.id = new Date().getTime() + ''
        //         addDocQuotationCalculation(this.form).then(res => {
        //             if (res.code == 200) {
        //                 this.quotationShow = false
        //                 this.getList()
        //             }
        //         })
        //     }
        // }
    }
}
</script>
<style lang="scss" scoped>
.quotation {
    padding: 0.32rem;
    font-size: .4rem;

    .title,
    h1,
    .button {
        text-align: center;
    }

    h2 {
        font-size: 0.48rem;
        line-height: 2rem;
        text-align: center;
    }

    .form {
        dd {
            line-height: 1rem;
        }

        .form-item {
            padding-bottom: 15px;

            label {
                display: inline-block;
                width: 3.5rem;
                text-align: right;
                vertical-align: middle;
            }
        }

        input[type='text'] {
            padding: 4px 8px;
            text-align: center;
            width: 80px;
        }
    }

    .button-wapper {
        text-align: center;
    }

    .button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 0;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 8px 15px;
        width: 80px;
        font-size: 12px;
        border-radius: 4px;
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
    }

    .tip {
        font-size: 14px;
        line-height: 0.6rem;
    }

    .result {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: #dcdfe6;
        padding: 16px;
        text-align: center;
        box-sizing: border-box;

        .button-result {
            width: 100%;
            height: 80px;
            position: absolute;
            bottom: 0;
            margin-left: -16px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/quotation2/quotation-item.vue